import {
  ALERT_DEFAULT_CONFIGURATION,
  LIST_DAMAGE_TYPE_DATA,
  LIST_DAMAGE_TYPE_DATA_CLIENT,
  LIST_DATA_TYPE_DATA,
  LIST_DATA_TYPE_DATA_CLIENT,
  LIST_DATA_TYPE_DATA_COMPANY,
  LIST_SEVERITY_TYPE_DATA,
  LIST_SEVERITY_TYPE_DATA_CLIENT,
  SET_CLIENT_ASSET_TYPES,
  SET_CLIENT_ASSET_TYPES_2,
  SET_COMPNAY_LOGO_URL,
  LIST_DATA_TYPE_DATA_PLAN,
  SET_LOADING_PLAN_DATA_TYPE,
} from '../actions/types';
const initialState = {
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  damageData: [],
  clientDamageData: [],
  severityData: [],
  clientSeverityData: [],
  isOpen: false,
  editData: {},
  isAlert: false,
  alertType: null,
  alertMessage: null,
  clientAssetTypes: [],
  clientAssetTypes2: [],
  companyLogo: '',
  dataTypeData: [],
  dataTypeDataCompany: [],
  dataTypeDataClient: [],
  dataTypeDataPlan: [],
  dataTypeDataPlanLoading: false,
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING_PLAN_DATA_TYPE:
      return {
        ...state,
        dataTypeDataPlanLoading: payload,
      };
    case SET_COMPNAY_LOGO_URL:
      return {
        ...state,
        companyLogo: payload,
      };
    case LIST_DATA_TYPE_DATA_PLAN:
      return {
        ...state,
        dataTypeDataPlan: payload,
      };
    case LIST_DATA_TYPE_DATA_CLIENT:
      return {
        ...state,
        dataTypeDataClient: payload,
      };
    case LIST_DATA_TYPE_DATA_COMPANY:
      return {
        ...state,
        dataTypeDataCompany: payload,
      };
    case LIST_DATA_TYPE_DATA:
      return {
        ...state,
        dataTypeData: payload,
      };
    case LIST_DAMAGE_TYPE_DATA_CLIENT:
      return {
        ...state,
        clientDamageData: payload,
      };
    case LIST_SEVERITY_TYPE_DATA:
      return {
        ...state,
        severityData: payload,
      };
    case SET_CLIENT_ASSET_TYPES:
      return {
        ...state,
        clientAssetTypes: payload,
      };
    case SET_CLIENT_ASSET_TYPES_2:
      return {
        ...state,
        clientAssetTypes2: payload,
      };
    case LIST_SEVERITY_TYPE_DATA_CLIENT:
      return {
        ...state,
        clientSeverityData: payload,
      };
    case ALERT_DEFAULT_CONFIGURATION:
      return {
        ...state,
        isAlert: payload.isError,
        alertType: payload.errorType,
        alertMessage: payload.message,
      };
    case LIST_DAMAGE_TYPE_DATA:
      return {
        ...state,
        damageData: payload,
      };
    default:
      return state;
  }
}

export default companyReducer;
